import React from 'react';
import './JourneyRibbon.css';

/**
 * Presentational journey ribbon: Aim → Plan → Practice → Momentum.
 * Every step is a real control that navigates the /my-ai experience.
 * done-states are truthful — derived from the caller's live goal/plan/entry data.
 */
const JourneyRibbon = ({ goal, plan, hasEntryToday, onAim, onPlan, onPractice, onMomentum }) => {
  const steps = [
    { key: 'aim', label: 'Aim', done: !!goal, onClick: onAim },
    { key: 'plan', label: 'Plan', done: !!plan, onClick: onPlan },
    { key: 'practice', label: 'Practice', done: hasEntryToday, onClick: onPractice },
    { key: 'momentum', label: 'Momentum', done: !!goal && !!plan && hasEntryToday, onClick: onMomentum }
  ];

  return (
    <nav className="journey-ribbon" aria-label="Your journey">
      {steps.map((step, index) => (
        <React.Fragment key={step.key}>
          {index > 0 && <span className="journey-connector" aria-hidden="true" />}
          <button
            type="button"
            className={`journey-step ${step.done ? 'done' : ''}`}
            aria-label={step.label}
            onClick={step.onClick}
          >
            <span className="journey-step-dot" aria-hidden="true" />
            <span className="journey-step-label">{step.label}</span>
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default JourneyRibbon;
